import { ColumnDef } from "@tanstack/react-table";
import { DcddMembershipPlanProp } from "../../store/actionType";
import ActionButton from "../ActionButton";
import { DcddMembershipStatus } from "props/enum";


export const TableColumns: ColumnDef<DcddMembershipPlanProp>[] = [

  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
      accessorFn: (row) => row?.membership_plan,
      id: "membership_plan",
      cell: (info) => info.getValue(),
      header: () => <span>DCDD Membership Plan</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.user_limit,
      id: "user_limit",
      cell: (info) => info.getValue(),
      header: () => <span>User Limit</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.join_date,
      id: "join_date",
      cell: (info) => info.getValue(),
      header: () => <span>Membership Start Data</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.end_date,
      id: "end_date",
      cell: (info) => info.getValue(),
      header: () => <span>Membership End Data</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.remarks,
      id: "remarks",
      cell: (info) => info.getValue(),
      header: () => <span>Remarks</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.status,
      id: "status",
      cell: (info) => {
        const status = info.getValue();
        return (
          <span
            className={
              status === DcddMembershipStatus.Active ? "text-primary-500" : "text-red-500"
            }
          >
            {String(status)}
          </span>
        );
      },
      header: () => <span>Status</span>,
      filterFn: "equalsString",
    },
  {
    id: "action",
    cell: ({ row }) => {

      return (

      <div className="flex justify-center items-center gap-2">
       <ActionButton items={row.original}/>
      </div>
    )},
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
